<template>
  <div>
    <div v-if="errors.length >= 1">
      {{ errors }}
    </div>
    <card>
      <div class="container">
        <div class="row">
          <div class="col-md-12 text-center">
            List of Positions
            <vuetable ref="positions"
                      :fields="columns"
                      :api-mode="false"
                      :data="positions"
            ></vuetable>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
import { RosterAPIService } from '../../servicehandlers/RosterHandler';
import loginCheckMixin from '@/mixin';
import Vuetable from 'vuetable-2';

const rosterAPIService = new RosterAPIService();

export default {
  name: 'Positions',
  components: {
    Vuetable
  },
  mixins: [loginCheckMixin],
  data: () => ({
    state: null,
    login: {},
    errors: [],
    positions: [],
    options: {},
    columns: ['id', 'name'],
  }),

  mounted() {
    this.getShifts();
  },

  methods: {
    // manual submit login detected.
    getShifts() {
      rosterAPIService.getPositions(this.$router)
      .then((resp) => {
        console.log('Resp: ', resp);
        this.positions = resp;
      })
      .catch((error) => {
        console.log('Error: ', error);
      });
    },
  },
}
</script>

<style>
input {
  text-align: left;
}
</style>

